import gql from 'graphql-tag';

import { useAdminUserListViewQuery } from '@/@generated/codegen/API';
import { usePaginationState } from '@/hooks/usePaginationState';
import { PageLoading } from '@/ui/PageLoading';
import { usePrevious } from '@/utils/helpers/react.helper';

import { AdminUserListView } from './AdminUserListView';
import { useAdminUserListQueryParams } from './hooks/useAdminUserListQueryParams';

gql`
  query AdminUserListView(
    $paginationArgs: PaginationArgs!
    $orderByArgs: OrderByArgs
    $where: UserWhereInput
  ) {
    listUsers(paginationArgs: $paginationArgs, orderByArgs: $orderByArgs, where: $where) {
      edges {
        node {
          ...UserFields
          client {
            ...ClientFields
          }
          team {
            ...TeamFields
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

const PAGE_SIZE = 15;
export const usersTablePrefix = 'users';

export const AdminUserListClient = () => {
  const { paginationArgs, orderByArgs, where } = useAdminUserListQueryParams(
    PAGE_SIZE,
    usersTablePrefix
  );
  const users = useAdminUserListViewQuery({
    variables: {
      paginationArgs,
      orderByArgs,
      where,
    },
  });
  const previousUsersData = usePrevious(users.data);
  const pagination = usePaginationState(PAGE_SIZE, usersTablePrefix);

  if (!previousUsersData && !users.data) {
    return <PageLoading />;
  }

  return (
    <AdminUserListView
      data={users.data || previousUsersData!}
      pagination={pagination}
      tablePrefix={usersTablePrefix}
    />
  );
};
